import * as _ from 'lodash'
import { IBusinessObject } from '../PA.Core/PA.Core.IF.BO';
import { IMessageProvider, IProgressProvider, MessageType } from '../PA.Core/PA.Core.IF.Basic';
import { PAdbContext } from '../PA.Core/PAdbContext';
import { IdentityProvider } from '../PA.Core/Basic/Identity'
import { MessageProvider } from '../PA.Core/Basic/Messages'
import { ProgressProvider } from '../PA.Core/Basic/Progress'
import {

    WB_ClaimRow,
    WB_CustomerRow, WB_FundingAccountRow,
    WB_PaymentClaimRow,
    WB_PaymentEventSpendRow,
    WB_PaymentFundRow,
    WB_PaymentRow,
    WB_PaymentTypeRow,
    WB_PeriodRow,
    WB_PlanRow,
    WB_ProductGroupRow,
    WB_TPM_EventSpendRow,
    WB_WorkflowStatusRow
} from "../PA.Core/PAdbSchemaRows";
import { IwbPayment } from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Claim,
    esWB_Claim_Type,
    esWB_Claim_Type_Payment_Type,
    esWB_Customer,
    esWB_Event_Spend_Type,
    esWB_Event_Type, esWB_Funding_Account,
    esWB_Payment,
    esWB_Payment_Claim,
    esWB_Payment_Event_Spend,
    esWB_Payment_Event_Spend_Product_Group,
    esWB_Payment_Fund,
    esWB_Payment_Fund_Product_Group,
    esWB_Payment_Type,
    esWB_Period,
    esWB_Plan,
    esWB_Product_Group, esWB_TPM_Event,
    esWB_TPM_Event_Spend, esWB_Workflow_Status
} from "../PA.Core/PAdbSchema";
import { ESRecord } from "../PA.Core/lib/ESRecord";
import { ESDataStore } from "../PA.Core/lib/ESDataStore";
import { PAusrContext } from "../PA.Core/PAusrContext";
import { PAEnvironment } from "../PA.Core/PAEnvironment";
import { WorkflowStatusService } from "../PA.MD.Services/WorkflowStatusService";
import { CreateOptions, ESRecordResolver } from "../PA.Core/lib/ESRecordResolver";
import { ASync } from "../PA.Core/Basic/ASync";
import { IHaveWorkflow, IWorkflowProcessor } from "../PA.Core/PA.Core.IF.Workflow";
import { WorkflowProcessor } from "../PA.Core/Workflow/WorkflowProcessor";
import { PaymentBOStandardWorkflowExtension } from "./PaymentBO.StdWorkflowExt";
import { IPolicyCollection } from "../PA.Core/PA.Core.IF.Policy";
import { IHaveSecurity } from "../PA.Core/PA.Core.IF.Aspects";
import { PolicyHasRole } from "../PA.Core/Security/PolicyHasRole";
import { PolicyBOis } from "../PA.Core/Security/PolicyBOis";
import { PolicyCollection } from '../PA.Core/Security/PolicyCollection';
import { PaymentBOStandardPolicy } from "./PaymentBO.StdPolicy";
import { Role_Super_User, Role_TPM_Payment_Approver, Role_TPM_Payment_Editor } from "../PA.Core/Security/Roles";
import {
    IHavePaymentClaims,
    IHavePaymentEventSpends,
    IHavePaymentFunds
} from "../PA.Settlements.Core/PA.Settlements.IF.Aspects";
import { BehaviorSubject } from "rxjs";
import { PaymentBOValidations } from "./PaymentBOValidations";

export interface IPaymentLoadNewOptions {
    wbPaymentTypeId: number,
    wbClaimId?: number | number[],
    wbFundingCustomerId?: number,
    wbPlanningCustomerId?: number,
    wbClaimCustomerId?: number,
    dbContext?: PAdbContext
}

export interface IPaymentLoadOptions {
    dbContext?: PAdbContext,
    RecordResolver?: ESRecordResolver
}

export interface IPaymentSaveValidateOptions {
    Validate?: {
        bSkipAllValidations?: boolean
    },
    Save?: {
        bSkipWorkflowProcessing?: boolean
    }
}

const PaymentSaveValidateOptions_default: IPaymentSaveValidateOptions = {
    Validate: {
        bSkipAllValidations: false
    },
    Save: {}
}

export class PaymentBO
    implements IBusinessObject,
    IHaveSecurity,
    IHaveWorkflow,
    IHavePaymentClaims,
    IHavePaymentEventSpends,
    IHavePaymentFunds {
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: IPaymentLoadNewOptions | IPaymentLoadOptions;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    _bIsLoadedInternal: boolean;
    _OnLoadCompleteInternal: Promise<PaymentBO>
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_Payment: WB_PaymentRow;

    usrContext: PAusrContext;

    dctAuditedDeletes: { [id: number]: number }

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.usrContext = PAEnvironment.getValue(PAEnvironment.UserContext);

        this.Identity = new IdentityProvider({ id: 0, name: 'New Payment' });

        this.LoadOptions = {}
        this._bIsLoaded = false
        this._OnLoadComplete = null
        this._bIsLoadedInternal = false
        this._OnLoadCompleteInternal = undefined
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_Payment = null;
        this.dctAuditedDeletes = {}

        this.IHavePaymentClaims_init()
        this.IHavePaymentFunds_init()
        this.IHavePaymentEventSpends_init()
        this.IHaveSecurity_init()
        //this.IHavePaymentStandardCalculator_init()
        this.IHaveWorkflow_init()
    }

    get WB_Payment(): WB_PaymentRow {
        return this.drWB_Payment;
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: IPaymentLoadNewOptions): Promise<IBusinessObject> {
        const self = this;

        let opts: IPaymentLoadNewOptions = options || <any>{}
        self.LoadProgressProvider.start("Creating Payment");

        self.LoadOptions = opts;

        const returnValue = self._OnLoadComplete = (async (): Promise<IBusinessObject> => {

            try {
                if ('dbContext' in opts)
                    self.dbContext = opts.dbContext;
                else
                    self.dbContext = new PAdbContext();

                if (_.isEmpty(self.dbContext)) {
                    let sError = "Unable to determine dbContext for new Payment.";
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(sError);
                    throw new Error(sError)
                }

                // Create record using dbContext
                let aPmtTypeRow: WB_PaymentTypeRow = await self.dbContext.find(esWB_Payment_Type, opts.wbPaymentTypeId)
                if (_.isEmpty(aPmtTypeRow)) {
                    let sError = "Unable to determine Payment Type for new Payment.";
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(sError);
                    throw new Error(sError)
                }
                await aPmtTypeRow.loadRelations([esWB_Claim_Type_Payment_Type])

                /*
                let aBusinessUnitRow: WB_BusinessUnitRow = <any>_.first(await self.dbContext.findUsingCache(esWB_BusinessUnit, [aPmtTypeRow.cif.WB_BUSINESSUNIT_ID]))
                if (_.isEmpty(aBusinessUnitRow)) {
                    let sError = "Unable to determine Business Unit for new Payment.";
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(sError);
                    throw new Error(sError)
                }*/

                let newPaymentRow: WB_PaymentRow = <any>await self.dbContext.createRecordWithKey(esWB_Payment)

                newPaymentRow.setDefaults()
                self.drWB_Payment = newPaymentRow;
                //  self.drWB_Payment.cif.WB_BUSINESSUNIT_ID = aPmtTypeRow.cif.WB_BUSINESSUNIT_ID
                //  self.drWB_Payment.WB_BusinessUnitRow = aBusinessUnitRow
                self.drWB_Payment.cif.WB_PMTTYPE_ID = aPmtTypeRow.cif.WB_PMTTYPE_ID
                self.drWB_Payment.WB_PaymentTypeRow = aPmtTypeRow
                self.drWB_Payment.cif.CURRENCY = aPmtTypeRow.cif.CURRENCY_DEFAULT

                if (self.usrContext?.Context_WB_SalesOrgRow)
                    self.drWB_Payment.cif.WB_SALESORG_ID = self.usrContext.Context_WB_SalesOrgRow.cif.WB_SALESORG_ID

                if (_.isNumber(opts.wbFundingCustomerId)) {
                    let aFundingCustomerRow: WB_CustomerRow = <any>_.first(await self.dbContext.findUsingCache(esWB_Customer, [opts.wbFundingCustomerId]))
                    if (!_.isEmpty(aFundingCustomerRow)) {
                        self.drWB_Payment.cif.WB_CUST_ID_FUNDING = aFundingCustomerRow.cif.WB_CUST_ID
                        self.drWB_Payment.WB_CustomerRow_Funding = aFundingCustomerRow
                    }
                }

                if (_.isNumber(opts.wbPlanningCustomerId)) {
                    let aPlanningCustomerRow: WB_CustomerRow = <any>_.first(await self.dbContext.findUsingCache(esWB_Customer, [opts.wbPlanningCustomerId]))
                    if (!_.isEmpty(aPlanningCustomerRow)) {
                        self.drWB_Payment.cif.WB_CUST_ID_PLANNING = aPlanningCustomerRow.cif.WB_CUST_ID
                        self.drWB_Payment.WB_CustomerRow_Planning = aPlanningCustomerRow
                    }
                }

                // Default Pay To Customer from the Claim Customer (AB#1744618). Unlike the earlier
                // AB#1739645 behavior, this no longer requires the Claim Customer to already be a
                // configured Pay To relationship for the Planning Customer — Pay To always defaults
                // to the Claim Customer, and the user can still change it from the Pay To dropdown.
                // A lookup failure must not block Payment creation — it degrades to leaving Pay To blank.
                if (_.isNumber(opts.wbClaimCustomerId)) {
                    try {
                        let aPayToCustomerRow: WB_CustomerRow = <any>_.first(await self.dbContext.findUsingCache(esWB_Customer, [opts.wbClaimCustomerId]))
                        if (!_.isEmpty(aPayToCustomerRow)) {
                            self.drWB_Payment.cif.WB_CUST_ID_PAYTO = aPayToCustomerRow.cif.WB_CUST_ID
                            self.drWB_Payment.WB_CustomerRow_PayTo = aPayToCustomerRow
                        }
                    } catch (err) {
                        console.log("Unable to default Pay To Customer from Claim Customer; leaving Pay To Customer blank.", err)
                    }
                }

                self.dbContext.add(esWB_Payment, self.drWB_Payment)
                self.Identity.setAll(self.WB_Payment.cif.WB_PMT_ID, self.WB_Payment.cif.PAYMENT_ID, self.WB_Payment.cif.PAYMENT_NAME);
                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                await self._AfterBoLoadCompleteInternal()

                self.LoadProgressProvider.finish();
                self._bIsLoaded = true;
                self._OnLoadComplete = null;
                return self;

            } catch (err) {
                self.LoadProgressProvider.exception(err)
                return self
            }
        })();

        return returnValue
    }

    Load(anId: number, options?: IPaymentLoadOptions): Promise<IBusinessObject> {
        const self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");

        let opts: IPaymentLoadOptions = options || <any>{};

        let internalLoad = self._OnLoadCompleteInternal = (async (): Promise<PaymentBO> => {

            if (self.bIsLoaded)
                return self

            self.LoadOptions = opts;

            if ('dbContext' in opts)
                self.dbContext = opts.dbContext;
            else if (_.isEmpty(self.dbContext)) {
                self.dbContext = new PAdbContext({});
            }

            if (_.isEmpty(self.dbContext)) {
                throw new Error("Unable to determine dbContext for new Payment.")
            }

            if ('RecordResolver' in opts) {
                recordResolver = opts.RecordResolver
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = PaymentBO.createRecordResolver({ dbContext: self.dbContext })
                recordResolverLoadPromise = PaymentBO.setupRecordResolver(recordResolver, [anId])
            }

            await recordResolverLoadPromise

            let aPaymentRow: any = recordResolver.get(esWB_Payment, anId)

            if (_.isEmpty(aPaymentRow)) {
                console.log("Payment Record Resolver unable to locate Payment for id: ", anId)
                throw new Error("Payment not Found");
            }

            self.drWB_Payment = aPaymentRow;
            await self.Identity.setAll(self.WB_Payment.cif.WB_PMT_ID, self.WB_Payment.cif.PAYMENT_ID, self.WB_Payment.cif.PAYMENT_NAME);
            self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

            self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
            self.Identity.listenToRecordUpdates(self.WB_Payment, 'WB_PMT_ID', 'PAYMENT_ID', 'PAYMENT_NAME')

        })();

        let returnValue = self._OnLoadComplete = (async (): Promise<IBusinessObject> => {

            try {
                await internalLoad

                // Run after Load
                self._bIsLoadedInternal = true
                self._OnLoadCompleteInternal = undefined
                await self._AfterBoLoadCompleteInternal()


                self._bIsLoaded = true;
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.finish()
                return self

            } catch (err) {
                self._OnLoadCompleteInternal = undefined;
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(err);
                return self
            }

        })();

        return returnValue;
    }

    private async _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;

        self.LoadProgressProvider.setProgressMessage('Payment.PostLoad', 'Processing Loaded Data');
        if (self.WB_Payment.WB_PaymentTypeRow.cif.WORKFLOW_POLICY != 'None') {
            if (self.WB_Payment.cif.WB_STATUS_ID == 0) {
                let initStatus: WB_WorkflowStatusRow = await WorkflowStatusService.getInitialWorkflowStatusByWorkflowWbID(self.WB_Payment.WB_PaymentTypeRow.cif.WB_WORKFLOW_ID)
                if (!_.isEmpty(initStatus)) {
                    self.drWB_Payment.cif.WB_STATUS_ID = initStatus.cif.WB_STATUS_ID
                    self.drWB_Payment.cif.WB_STATUS_ID_NEXT = initStatus.cif.WB_STATUS_ID
                }
            } else if (self.WB_Payment.cif.WB_STATUS_ID_NEXT == 0) {
                self.drWB_Payment.cif.WB_STATUS_ID_NEXT = self.drWB_Payment.cif.WB_STATUS_ID
            }
        }

        await self.IHaveWorkflow_OnLoadComplete()
        //await self.IHavePaymentCalculator_OnLoadComplete()
        await self.IHaveSecurity_OnLoadComplete()
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    async Validate(options?: any): Promise<IBusinessObject> {

        const self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_Payment.cif.PAYMENT_NAME + "(" + self.WB_Payment.cif.PAYMENT_ID + ")");

        // Does no validations yet
        self.ValidateOptions = options || {};

        if (_.isEmpty(self.dbContext)) {
            const sError = "Unable to determine dbContext for to Validate Payment.";
            self.ValidateProgressProvider.exception(sError);
            throw new Error(sError);
        }

        // Recompute PAYMENT_AMT from the current tactic/fund/claim lines so a standalone Validate
        // (without a preceding Save) doesn't check the approval limit against a stale total.
        await self.BeforeSave()

        await PaymentBOValidations.Validate(self)

        if (self.ValidateMessageProvider.countMessages(MessageType.Error) == 0) {

            for (let idx = 0; idx < self.WorkflowProcessors.length; idx++) {
                let aWfProcessor = self.WorkflowProcessors[idx]
                await aWfProcessor.Validate()
                self.ValidateMessageProvider.addMessages(aWfProcessor.WorkflowMessageProvider.Messages)
            }
        }

        if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
            self._bIsValidated = false;
        } else {
            self._bIsValidated = true;
        }

        self.ValidateProgressProvider.finish();
        return self
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    private BeforeSave(): void {
        const self = this;

        // Update Totals
        let totalFundedPmtAmt = 0
        let totalClaimAmt = 0
        let totalClaimPmtSettleAmt = 0
        let bHasAnyActiveLine = false

        _.forEach(self.WB_Payment.WB_PaymentEventSpendRows, (aRow) => {
            if (!aRow.isActive)
                return

            bHasAnyActiveLine = true
            totalFundedPmtAmt += aRow.cif.PAYMENT_AMT
        })

        _.forEach(self.WB_Payment.WB_PaymentFundRows, (aRow) => {
            if (!aRow.isActive)
                return

            bHasAnyActiveLine = true
            totalFundedPmtAmt += aRow.cif.PAYMENT_AMT
        })

        _.forEach(self.WB_Payment.WB_PaymentClaimRows, (aRow) => {
            if (!aRow.isActive)
                return
            if (_.isEmpty(aRow.WB_ClaimRow))
                return
            bHasAnyActiveLine = true
            totalClaimAmt += aRow.WB_ClaimRow.cif.CLAIM_AMT
            totalClaimPmtSettleAmt += aRow.cif.PAYMENT_AMT
        })

        // Only recompute when there's at least one active tactic/fund/claim line — otherwise leave
        // PAYMENT_AMT as-is rather than zeroing out a value set some other way.
        if (bHasAnyActiveLine) {
            self.WB_Payment.cif.PAYMENT_AMT = totalFundedPmtAmt
            self.WB_Payment.cif.REQUESTED_AMT = totalClaimAmt
        }

    }

    Save(options?: any): Promise<IBusinessObject> {
        this.dbContext.BatchStart()
        return this.SaveUsing(true, false, true, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, true, false, options)
    }

    private async SaveUsing(bUseBatchFunction: boolean, bUseBatchCallback: boolean, bCallBatchComplete: boolean, options?: IPaymentSaveValidateOptions): Promise<IBusinessObject> {
        const self = this;

        const wbPayment = <IwbPayment>self.drWB_Payment;
        self.SaveProgressProvider.start("Saving " + wbPayment.PAYMENT_NAME + "(" + wbPayment.PAYMENT_ID + ")");


        if (_.isEmpty(self.dbContext)) {
            self._bIsSaved = false;
            const sError = "Unable to determine dbContext to Save Period.";
            self.SaveProgressProvider.exception(sError);
            throw new Error(sError)
        }

        self.BeforeSave()

        let opts: IPaymentSaveValidateOptions = options || {}
        self.SaveOptions = opts;

        let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
        if (bUseBatchFunction) {
            saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
        } else {
            saveFunction = self.dbContext.Save.bind(self.dbContext)
        }

        // if (self.ValidateMessageProvider.countMessages(MessageType.Error) == 0)
        // {self.SaveProgressProvider.setPercentComplete(0.1)}
        let validatePromise = undefined
        if (opts?.Validate?.bSkipAllValidations) {
            self._bIsValidated = true
        } else {
            await self.Validate(opts)
        }

        if (!self.bIsValidated) {
            self._bIsSaved = false;
            self.SaveProgressProvider.finish();
            return self
        }

        let tasks: Promise<any>[] = []
        tasks.push(saveFunction(esWB_Payment, self.drWB_Payment, {}))
        tasks.push(saveFunction(esWB_Payment_Event_Spend, self.drWB_Payment.WB_PaymentEventSpendRows))
        let arrSpendPGs = _.flatMap(self.drWB_Payment.WB_PaymentEventSpendRows, (aRow) => aRow.WB_PaymentEventSpendProductGroupRows)
        tasks.push(saveFunction(esWB_Payment_Event_Spend_Product_Group, arrSpendPGs))
        tasks.push(saveFunction(esWB_Payment_Fund, self.drWB_Payment.WB_PaymentFundRows))
        let arrFundPGs = _.flatMap(self.drWB_Payment.WB_PaymentFundRows, (aRow) => aRow.WB_PaymentFundProductGroupRows)
        tasks.push(saveFunction(esWB_Payment_Fund_Product_Group, arrFundPGs))
        tasks.push(saveFunction(esWB_Payment_Claim, self.drWB_Payment.WB_PaymentClaimRows))

        await Promise.all(tasks)

        if (!(opts?.Save?.bSkipWorkflowProcessing)) {
            for (let idx = 0; idx < self.WorkflowProcessors.length; idx++) {
                let aWfProcessor = self.WorkflowProcessors[idx]
                await aWfProcessor.Save(bUseBatchFunction)
            }
        }

        if (bUseBatchCallback) {
            self.dbContext.addBatchCompleteListener(() => {
                self._bIsSaved = true;

                if (!opts?.Save?.bSkipWorkflowProcessing)
                    self.AfterSaveCompleted()
            })
        } else {
            self._bIsSaved = true;
            if (bCallBatchComplete) {
                await self.dbContext.BatchComplete()
            }

            if (!opts?.Save?.bSkipWorkflowProcessing)
                await self.AfterSaveCompleted()

        }
        self.SaveProgressProvider.finish();
        return self

    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    get bIsApprovedOrClosed(): boolean {
        let currentState = this.PrimaryWorkflowProcessor?.CurrentState
        return !!currentState && (currentState.StatusTypeApproved || currentState.StatusTypeClosed)
    }

    private async AfterSaveCompleted(): Promise<void> {
        const self = this

        for (let idx = 0; idx < self.WorkflowProcessors.length; idx++) {
            let aWfProcessor = self.WorkflowProcessors[idx]
            await aWfProcessor.OnSaved()
        }

    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private async DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;
        const wbPayment = <IwbPayment>self.drWB_Payment;

        self.DeleteMessageProvider.clearMessages();
        self.DeleteProgressProvider.start("Deleting " + wbPayment.PAYMENT_NAME + "(" + wbPayment.WB_PMT_ID + ")");


        // 1. Validate if we can delete the Payment
        await PaymentBOValidations.ValidateBeforeDelete(self)

        if (self.DeleteMessageProvider.countMessages(MessageType.Error) > 0) {
            self.DeleteProgressProvider.finish();
            return self
        }

        // 2. If Valid, mark all the records for deletion.
        self.drWB_Payment.markDeleted()
        _.forEach(self.drWB_Payment.WB_PaymentClaimRows, (a) => {
            a.markDeleted()
        })
        _.forEach(self.drWB_Payment.WB_PaymentEventSpendRows, (a) => {
            _.forEach(a.WB_PaymentEventSpendProductGroupRows, (b) => {
                b.markDeleted()
            })
            a.markDeleted()
        })
        _.forEach(self.drWB_Payment.WB_PaymentFundRows, (a) => {
            _.forEach(a.WB_PaymentFundProductGroupRows, (b) => {
                b.markDeleted()
            })
            a.markDeleted()
        })

        if (bSaveNow) {
            try {
                self.dbContext.BatchStart()
                await self.SaveUsing(true, false, true, {
                    Save: { bSkipWorkflowProcessing: true },
                    Validate: { bSkipAllValidations: true }
                })
                self.OnPaymentEventSpendCollectionChanged.next(self)
                self.OnPaymentClaimCollectionChanged.next(self)
                self.OnPaymentEventSpendCollectionChanged.next(self)

                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                return self;

            } catch (err) {
                self.DeleteProgressProvider.exception(err)
                return self
            }
        } else {
            self._bIsDeleted = true;
            self.DeleteProgressProvider.finish();
            return self;
        }
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveSecurity operations">

    private _PolicyCollection: IPolicyCollection;
    private _bIHaveSecurityLoaded: boolean;
    private _OnIHaveSecurityLoaded: Promise<IHaveSecurity>

    IHaveSecurity_init() {
        this._PolicyCollection = new PolicyCollection()
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
    }

    IHaveSecurity_BeforeReload() {
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
    }

    IHaveSecurity_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.OnIHaveSecurityLoaded
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    get OnIHaveSecurityLoaded(): Promise<IHaveSecurity> {
        const self = this

        if (self.bIHaveSecurityLoaded) {
            return ASync.resolve(this)
        }

        if (this._OnIHaveSecurityLoaded) {
            return this._OnIHaveSecurityLoaded
        }

        let aHasRolePolicy: PolicyHasRole
        let aStdPaymentPolicy: PaymentBOStandardPolicy

        self._OnIHaveSecurityLoaded = (async (): Promise<IHaveSecurity> => {

            let wbCustId = self.drWB_Payment.cif.WB_CUST_ID_FUNDING || self.drWB_Payment.cif.WB_CUST_ID_PLANNING

            let aBOis = new PolicyBOis([Role_TPM_Payment_Editor, Role_TPM_Payment_Approver], [Role_TPM_Payment_Approver], wbCustId)
            self.PolicyCollection.addPolicy("BOis", aBOis)
            aHasRolePolicy = new PolicyHasRole(wbCustId)
            await aHasRolePolicy.OnLoadComplete
            self.PolicyCollection.addPolicy("HasRole", aHasRolePolicy)
            aStdPaymentPolicy = new PaymentBOStandardPolicy(self)
            await aStdPaymentPolicy.OnLoadComplete
            self.PolicyCollection.addPolicy("Payment", aStdPaymentPolicy)
            this._bIHaveSecurityLoaded = true

            return self

        })();

        return this._OnIHaveSecurityLoaded
    }

    get PolicyCollection(): IPolicyCollection {
        return this._PolicyCollection
    }

    get bIHaveSecurityLoaded(): boolean {
        return this._bIHaveSecurityLoaded
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveWorkflow operations">

    private _WorkflowProcessors: IWorkflowProcessor[]
    private _PrimaryWorkflowProcessor: IWorkflowProcessor


    private IHaveWorkflow_init(): void {
        this._WorkflowProcessors = []
        this._PrimaryWorkflowProcessor = undefined
    }

    private IHaveWorkflow_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            // Reset Workflow Processors

            self._WorkflowProcessors = []
            let aWorkflowProcessor
                = new WorkflowProcessor(self.WB_Payment.WB_PaymentTypeRow.cif.WB_WORKFLOW_ID,
                    {
                        dbContext: self.dbContext,
                        AppMgr_Id: 'Payment',
                        WB_App_Id: self.WB_Payment.cif.WB_PMT_ID,
                        App_Id: self.WB_Payment.cif.PAYMENT_ID,
                        bLoadWorkflowHistory: true,
                        bLoadUserReviewers: false,
                        WB_Cust_Id: self.WB_Payment.cif.WB_CUST_ID_FUNDING || self.WB_Payment.cif.WB_CUST_ID_PLANNING,
                        object: self,
                        Record: self.WB_Payment,
                        CurrentStateIdFieldName: 'WB_STATUS_ID',
                        NextStateIdFieldName: 'WB_STATUS_ID_NEXT',
                        NextUserIdFieldName: 'WB_AUTHUSR_ID_WF_NEXT',
                        OwnerUserIdFieldName: 'WB_AUTHUSR_ID_CREATEDBY'
                    })
            let StdExtension = new PaymentBOStandardWorkflowExtension(self)
            aWorkflowProcessor.setExtensions([StdExtension])
            self._PrimaryWorkflowProcessor = aWorkflowProcessor
            self.PolicyCollection.addPolicy("Workflow", aWorkflowProcessor)

            aWorkflowProcessor.OnLoadComplete
                .then((ignore) => {
                    self._WorkflowProcessors.push(aWorkflowProcessor)
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })
    }

    private IHaveWorkflow_BeforeReload(): void {
        this._WorkflowProcessors = []
        this._PrimaryWorkflowProcessor = undefined
    }

    get WorkflowProcessors(): IWorkflowProcessor[] {
        return this._WorkflowProcessors
    }

    get PrimaryWorkflowProcessor(): IWorkflowProcessor {
        return this._PrimaryWorkflowProcessor
    }


    //</editor-fold>


    //<editor-fold desc = "IHavePaymentEventSpends operations">

    private _OnPaymentEventSpendCollectionChanged: BehaviorSubject<IHavePaymentEventSpends>

    private IHavePaymentEventSpends_init() {
        this._OnPaymentEventSpendCollectionChanged = new BehaviorSubject<IHavePaymentEventSpends>(this)
    }

    get OnPaymentEventSpendCollectionChanged(): BehaviorSubject<IHavePaymentEventSpends> {
        return this._OnPaymentEventSpendCollectionChanged
    }


    async addEventSpend(wbTEvtSId: number, options?: any): Promise<WB_PaymentEventSpendRow> {

        const self = this

        let aTEvtSRow: WB_TPM_EventSpendRow = <any>await self.dbContext.find(esWB_TPM_Event_Spend, wbTEvtSId, { with: [esWB_TPM_Event, esWB_Event_Spend_Type, esWB_Workflow_Status] })
        if (_.isEmpty(aTEvtSRow))
            return undefined
        let evt = aTEvtSRow.WB_TPM_EventRow
        if (!_.isEmpty(evt) && _.isEmpty(evt?.WB_EventTypeRow))
            await evt.loadRelations(esWB_Event_Type)
        if (!_.isEmpty(evt) && _.isEmpty(evt?.WB_PlanRow))
            await evt.loadRelations(esWB_Plan)

        let pln = evt?.WB_PlanRow
        if (!_.isEmpty(pln) && _.isEmpty(pln?.WB_WorkflowStatusRow))
            await pln.loadRelations(esWB_Workflow_Status)

        let aNewRow: WB_PaymentEventSpendRow = <any>await self.dbContext.createRecordWithKey(esWB_Payment_Event_Spend)
        aNewRow.setDefaults()
        aNewRow.cif.WB_PMT_ID = self.drWB_Payment.cif.WB_PMT_ID
        aNewRow.WB_PaymentRow = self.drWB_Payment
        aNewRow.cif.WB_TEVTS_ID = aTEvtSRow.cif.WB_TEVTS_ID
        aNewRow.WB_TPM_EventSpendRow = aTEvtSRow
        self.dbContext.add(esWB_Payment_Event_Spend, aNewRow)

        self.OnPaymentEventSpendCollectionChanged.next(self)
        return aNewRow
    }

    async removePaymentEventSpend(wbPmtEvtsId: number): Promise<void> {
        const self = this

        _.forEach(self.drWB_Payment.WB_PaymentEventSpendRows, (aPaymentEventSpendTypeRow: WB_PaymentEventSpendRow) => {
            if (aPaymentEventSpendTypeRow.isActive && aPaymentEventSpendTypeRow.cif.WB_PMTEVTS_ID == wbPmtEvtsId)
                aPaymentEventSpendTypeRow.markDeleted()

        })

        self.OnPaymentEventSpendCollectionChanged.next(self)

    }

    //</editor-fold>

    //<editor-fold desc = "IHavePaymentFunds operations">

    private _OnPaymentFundCollectionChanged: BehaviorSubject<IHavePaymentFunds>

    private IHavePaymentFunds_init() {
        this._OnPaymentFundCollectionChanged = new BehaviorSubject<IHavePaymentFunds>(this)
    }

    get OnPaymentFundCollectionChanged(): BehaviorSubject<IHavePaymentFunds> {
        return this._OnPaymentFundCollectionChanged
    }


    async addFundSpendByFundingAccount(wbFundingAccountId: number, options?: any): Promise<WB_PaymentFundRow> {
        const self = this

        let aFundingAccountRow: WB_FundingAccountRow = <any>await self.dbContext.find(esWB_Funding_Account, wbFundingAccountId, { with: [esWB_Plan] })
        if (_.isEmpty(aFundingAccountRow))
            return undefined
        let aNewRow: WB_PaymentFundRow = <any>await self.dbContext.createRecordWithKey(esWB_Payment_Fund)
        aNewRow.setDefaults()
        aNewRow.cif.WB_PMT_ID = self.drWB_Payment.cif.WB_PMT_ID
        aNewRow.WB_PaymentRow = self.drWB_Payment
        aNewRow.cif.WB_FUNDINGACCOUNT_ID = wbFundingAccountId
        aNewRow.WB_FundingAccountRow = aFundingAccountRow


        // Get Customer, Planning Level, Year from Funding Account
        if (aFundingAccountRow.cif.WB_CUST_ID_FINDING > 0) {
            let aCustomerRow: WB_CustomerRow = <any>await self.dbContext.find(esWB_Customer, aFundingAccountRow.cif.WB_CUST_ID_FINDING)
            aNewRow.cif.WB_CUST_ID_FUNDING = aFundingAccountRow.cif.WB_CUST_ID_FUNDING
            aNewRow.WB_CustomerRow = aCustomerRow
        }

        if (aFundingAccountRow.cif.WB_PRDGRP_ID_FUNDING > 0) {
            let aProductGroupRow: WB_ProductGroupRow = <any>await self.dbContext.find(esWB_Product_Group, aFundingAccountRow.cif.WB_PRDGRP_ID_FUNDING)
            aNewRow.cif.WB_PRDGRP_ID_FUNDING = aFundingAccountRow.cif.WB_PRDGRP_ID_FUNDING
            aNewRow.WB_ProductGroupRow = aProductGroupRow
        }

        if (aFundingAccountRow.cif.WB_PERIOD_ID > 0) {
            let aPeriodRow: WB_PeriodRow = <any>await self.dbContext.find(esWB_Period, aFundingAccountRow.cif.WB_PERIOD_ID)
            aNewRow.cif.WB_PERIOD_ID_FUNDING = aFundingAccountRow.cif.WB_PERIOD_ID
            aNewRow.WB_PeriodRow = aPeriodRow
        }


        self.dbContext.add(esWB_Payment_Fund, aNewRow)

        self.OnPaymentFundCollectionChanged.next(self)
        return aNewRow
    }

    async removeFundSpend(wbPmtFndId: number, options?: any): Promise<void> {
        const self = this

        _.forEach(self.drWB_Payment.WB_PaymentFundRows, (aPmtFndRow: WB_PaymentFundRow) => {
            if (aPmtFndRow.isActive && aPmtFndRow.cif.WB_PMTFND_ID == wbPmtFndId)
                aPmtFndRow.markDeleted()
        })

        self.OnPaymentFundCollectionChanged.next(self)
    }

    //</editor-fold>

    //<editor-fold desc = "IHavePaymentClaims operations">

    private _OnPaymentClaimCollectionChanged: BehaviorSubject<IHavePaymentClaims>

    private IHavePaymentClaims_init() {
        this._OnPaymentClaimCollectionChanged = new BehaviorSubject<IHavePaymentClaims>(this)
    }

    get OnPaymentClaimCollectionChanged(): BehaviorSubject<IHavePaymentClaims> {
        return this._OnPaymentClaimCollectionChanged
    }

    get bSingleClaimMode(): boolean {
        return ((this?.WB_Payment?.WB_PaymentTypeRow?.cif?.CLAIM_POLICY) == 'One')
    }

    get SinglePaymentClaim(): WB_PaymentClaimRow {
        if (!this.bSingleClaimMode)
            return undefined

        let rowCheck = _.filter(this.WB_Payment.WB_PaymentClaimRows, aRow => aRow.isActive)
        if (rowCheck.length > 1) {
            let msg = "Invalid State, Single claim payment has multiple Claims"
            console.log(msg)
            this.ValidateMessageProvider.addMessage({
                code: "SingleClaimErr",
                title: msg,
                description: msg,
                type: MessageType.Error
            })

            return undefined  // Don't show anything if multiple exist
        }

        return _.first(rowCheck)

    }

    get bMultiClaimMode(): boolean {
        return ((this?.WB_Payment?.WB_PaymentTypeRow?.cif?.CLAIM_POLICY) == 'Many')
    }

    get PaymentClaims(): WB_PaymentClaimRow[] {
        return _.filter(this.WB_Payment.WB_PaymentClaimRows, aRow => aRow.isActive)
    }

    get ClaimCount(): number {
        return this.PaymentClaims.length
    }


    async setClaim(wbClaimId: number, options?: any): Promise<WB_PaymentClaimRow> {
        const self = this
        let bFound = false
        let returnValue: WB_PaymentClaimRow = undefined

        // Once a payment is Approved/Closed, its claim association is locked -- mirrors the
        // enabled condition on the Switch Claim / Reset buttons in the Payment UI.
        if (self.bIsApprovedOrClosed)
            return undefined

        let claim: WB_ClaimRow = <any>await self.dbContext.find(esWB_Claim, wbClaimId)

        if (_.isEmpty(claim))
            return undefined

        if (!claim.isActive)
            return undefined

        let rowIdsToDelete: number[] = []
        _.forEach(self.WB_Payment.WB_PaymentClaimRows, (aRow) => {
            if (!aRow.isActive)
                return
            if (aRow.cif.WB_CLM_ID != wbClaimId)
                rowIdsToDelete.push(aRow.cif.WB_PMTCLMR_ID)
            else
                bFound = true
        })

        for (let aRowId of rowIdsToDelete) {
            await self.removeClaim(aRowId, {})
        }

        if (!bFound)
            returnValue = await self.addClaim(wbClaimId, {})

        self.OnPaymentClaimCollectionChanged.next(self)
        return returnValue

    }

    async clearClaim(): Promise<void> {
        const self = this

        if (!this.bSingleClaimMode)
            return undefined

        if (self.bIsApprovedOrClosed)
            return undefined

        let rowIdsToDelete: number[] = []
        _.forEach(self.WB_Payment.WB_PaymentClaimRows, (aRow) => {
            if (!aRow.isActive)
                return
            rowIdsToDelete.push(aRow.cif.WB_PMTCLMR_ID)
        })

        for (let aRowId of rowIdsToDelete) {
            await self.removeClaim(aRowId, {})
        }

        self.OnPaymentClaimCollectionChanged.next(self)

    }


    async addClaim(claim: number | WB_ClaimRow, options?: any): Promise<WB_PaymentClaimRow> {
        let self = this

        // Once a payment is Approved/Closed, its claim allocations are locked -- covers both the
        // single-claim Switch Claim button and the multi-claim grid, which both route through here.
        if (self.bIsApprovedOrClosed)
            return undefined

        // A brand-new, not-yet-saved Claim has no server-side record to find by id, so callers
        // creating a Payment from an in-progress Claim must pass the in-memory row directly.
        let aClaimRow: WB_ClaimRow = _.isNumber(claim)
            ? <any>await self.dbContext.find(esWB_Claim, claim, { with: [esWB_Claim_Type] })
            : claim
        if (_.isEmpty(aClaimRow))
            return undefined

        let aNewRow: WB_PaymentClaimRow = <any>await self.dbContext.createRecordWithKey(esWB_Payment_Claim)
        aNewRow.setDefaults()
        aNewRow.cif.WB_CLM_ID = aClaimRow.cif.WB_CLM_ID
        aNewRow.WB_ClaimRow = aClaimRow
        aNewRow.cif.WB_PMT_ID = self.drWB_Payment.cif.WB_PMT_ID
        aNewRow.WB_PaymentRow = self.drWB_Payment
        aNewRow.cif.PAYMENT_AMT = await self.getClaimRemainingAmt(aClaimRow)
        self.dbContext.add(esWB_Payment_Claim, aNewRow)
        self.OnPaymentClaimCollectionChanged.next(self)
        return aNewRow
    }

    // What's actually still owed on the claim -- its total less whatever other Approved/Closed
    // payments have already settled against it -- so adding it here doesn't default to overpayment.
    private async getClaimRemainingAmt(aClaimRow: WB_ClaimRow): Promise<number> {
        const self = this

        let rr = new ESRecordResolver(self.dbContext, {
            standardConditions: {
                [esWB_Payment_Claim]: { "DELETED_IND": { "notIn": ['1'] } }
            },
            dctIncludeBelongsToNamedRelations: {
                [esWB_Payment]: [esWB_Workflow_Status]
            }
        })

        let paymentClaimRows: WB_PaymentClaimRow[] = <any>await rr.queryAllWithRelationships(esWB_Payment_Claim, {
            where: {
                WB_CLM_ID: aClaimRow.cif.WB_CLM_ID,
                DELETED_IND: { "notIn": ['1'] }
            }
        })

        let settled = 0
        _.forEach(paymentClaimRows, (aRow) => {
            let wfStatus = aRow.WB_PaymentRow?.WB_WorkflowStatusRow
            if (wfStatus && (wfStatus.StatusTypeApproved || wfStatus.StatusTypeClosed))
                settled += aRow.cif.PAYMENT_AMT
        })

        return Math.max(0, aClaimRow.cif.CLAIM_AMT - settled)
    }

    async removeClaim(wbPmtClaimId: number, options?: any): Promise<void> {
        const self = this

        if (self.bIsApprovedOrClosed)
            return undefined

        _.forEach(self.drWB_Payment.WB_PaymentClaimRows, (aPmtClmRow: WB_PaymentClaimRow) => {
            if (aPmtClmRow.isActive && aPmtClmRow.cif.WB_PMTCLMR_ID == wbPmtClaimId)
                aPmtClmRow.markDeleted()
        })

        self.OnPaymentClaimCollectionChanged.next(self)
    }

    //</editor-fold>

    //<editor-fold desc = "IRecordResolverProvider   <<STATIC>> operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts)
            dbContext = opts.dbContext;
        else {
            dbContext = new PAdbContext({});
        }
        const pmt_options: CreateOptions = {
            standardConditions: {
                [esWB_Payment]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_Payment_Claim]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_Payment_Event_Spend]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_Payment_Event_Spend_Product_Group]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_Payment_Fund]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_Payment_Fund_Product_Group]: { "DELETED_IND": { "notIn": ['1'] } }
            },
            dctExcludeHasManyNamedRelations: {},
            dctIncludeBelongsToNamedRelations: {
                // This should match LoadNew loadRelations
                [esWB_Payment_Type]: [esWB_Claim_Type_Payment_Type],
                [esWB_Claim]: [esWB_Claim_Type],
                [esWB_TPM_Event_Spend]: [esWB_Event_Spend_Type, esWB_TPM_Event, esWB_Workflow_Status],
                [esWB_TPM_Event]: [esWB_Event_Type, esWB_Plan, esWB_Workflow_Status],
                [esWB_Plan]: [esWB_Workflow_Status]
            }

        }

        const aRecResolver = new ESRecordResolver(dbContext, pmt_options)

        return aRecResolver;

    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_Payment, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })

    }

    static concurrentLoadCountHint(): number {
        return 5;
    }

    //</editor-fold>

};

PAEnvironment.registerBusinessObjectClass(PaymentBO, "PaymentBO", "Payment")
